export const UserRoles = {
    ADMIN: 'admin',
  };